"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarApi = exports.CalendarApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
/**
 * CalendarApi - axios parameter creator
 * @export
 */
const CalendarApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ICalendarCreateManualEventBodyEntity} iCalendarCreateManualEventBodyEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvent: async (iCalendarCreateManualEventBodyEntity, options = {}) => {
            // verify required parameter 'iCalendarCreateManualEventBodyEntity' is not null or undefined
            (0, common_1.assertParamExists)('createEvent', 'iCalendarCreateManualEventBodyEntity', iCalendarCreateManualEventBodyEntity);
            const localVarPath = `/api/calendar/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCalendarCreateManualEventBodyEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} iCalUId
         * @param {string} email
         * @param {string} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvent: async (iCalUId, email, id, options = {}) => {
            // verify required parameter 'iCalUId' is not null or undefined
            (0, common_1.assertParamExists)('deleteEvent', 'iCalUId', iCalUId);
            // verify required parameter 'email' is not null or undefined
            (0, common_1.assertParamExists)('deleteEvent', 'email', email);
            const localVarPath = `/api/calendar/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (iCalUId !== undefined) {
                localVarQueryParameter['iCalUId'] = iCalUId;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} from
         * @param {string} to
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents: async (from, to, email, options = {}) => {
            // verify required parameter 'from' is not null or undefined
            (0, common_1.assertParamExists)('getEvents', 'from', from);
            // verify required parameter 'to' is not null or undefined
            (0, common_1.assertParamExists)('getEvents', 'to', to);
            const localVarPath = `/api/calendar/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ICalendarUpdateEventBodyEntity} iCalendarUpdateEventBodyEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvent: async (iCalendarUpdateEventBodyEntity, options = {}) => {
            // verify required parameter 'iCalendarUpdateEventBodyEntity' is not null or undefined
            (0, common_1.assertParamExists)('updateEvent', 'iCalendarUpdateEventBodyEntity', iCalendarUpdateEventBodyEntity);
            const localVarPath = `/api/calendar/events/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCalendarUpdateEventBodyEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CalendarApiAxiosParamCreator = CalendarApiAxiosParamCreator;
/**
 * CalendarApi -
 */
var CalendarApi;
(function (CalendarApi) {
    /**
     *
     * @param {ICalendarCreateManualEventBodyEntity} iCalendarCreateManualEventBodyEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof CalendarApi
     * url /api/calendar/events
     */
    async function createEvent(iCalendarCreateManualEventBodyEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.CalendarApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.createEvent(iCalendarCreateManualEventBodyEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    CalendarApi.createEvent = createEvent;
    /**
     *
     * @param {string} iCalUId
     * @param {string} email
     * @param {string} [id]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof CalendarApi
     * url /api/calendar/events
     */
    async function deleteEvent(iCalUId, email, id, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.CalendarApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEvent(iCalUId, email, id, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    CalendarApi.deleteEvent = deleteEvent;
    /**
     *
     * @param {string} from
     * @param {string} to
     * @param {string} [email]
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof CalendarApi
     * url /api/calendar/events
     */
    async function getEvents(from, to, email, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.CalendarApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.getEvents(from, to, email, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_1.parseICalendarEventLite)(x));
            return res;
        });
    }
    CalendarApi.getEvents = getEvents;
    /**
     *
     * @param {ICalendarUpdateEventBodyEntity} iCalendarUpdateEventBodyEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof CalendarApi
     * url /api/calendar/events/update
     */
    async function updateEvent(iCalendarUpdateEventBodyEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.CalendarApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateEvent(iCalendarUpdateEventBodyEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    CalendarApi.updateEvent = updateEvent;
})(CalendarApi || (exports.CalendarApi = CalendarApi = {}));
